<div class="wrapper" [class.wrapper-comparing]="isComparing" [class.check-ins-ux-improvements]="isCheckInsUxImprovementsEnabled" uiAlign="middle" ui-row>
  <i class="go-to-prev" *ngIf="!isCheckInsUxImprovementsEnabled" [attr.data-test-id]="'check-in-cadence-pager-left-arrow'" (click)="goToPrev()" ui-icon ui-col uiType="chevron-left-big"></i>
  <button *ngIf="isCheckInsUxImprovementsEnabled" (click)="goToPrev()" ui-button ui-col>
    <i class="go-to-prev fs-16px" [attr.data-test-id]="'check-in-cadence-pager-left-arrow'" ui-icon uiType="chevron-left-big"></i>
  </button>
  <div class="cadence-start-end" *ngIf="isComparing" ui-col>{{ prevCadenceStartDate | pagerDate }} - {{ prevCadenceEndDate | pagerDate }}</div>
  <div class="divider" *ngIf="isComparing" ui-col></div>
  <div class="cadence-start-end" [attr.data-test-id]="'check-in-cadence-pager-cadence'" ui-col>{{ cadenceStartDate | pagerDate }} - {{ cadenceEndDate | pagerDate }}</div>
  <ng-container *ngIf="!isCheckInsUxImprovementsEnabled">
    <i class="go-to-next" [class.go-to-next-disabled]="!canGoToLatest()" (click)="goToNext()" ui-icon uiType="chevron-right-big"></i>
    <i class="go-to-latest" *ngIf="canGoToLatest()" (click)="goToLatest()" ui-icon uiType="chevron-right-double-big"></i>
  </ng-container>
  <div class="next-cadence" *ngIf="isCheckInsUxImprovementsEnabled" ui-col>
    <button [disabled]="!canGoToLatest()" (click)="goToNext()" ui-button>
      <i class="go-to-next fs-16px" [class.go-to-next-disabled]="!canGoToLatest()" ui-icon uiType="chevron-right-big"></i>
    </button>
    <button class="go-to-latest" *ngIf="canGoToLatest()" (click)="goToLatest()" ui-button>
      <i class="fs-16px" ui-icon uiType="chevron-right-double-big"></i>
    </button>
  </div>
</div>
